"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var GapBridgingConfig = function GapBridgingConfig(a) {
  this.maxXGap = 50, this.maxYGap = 50, this.maxTimeGap = 300, this.enabled = !0, this.maxXGap = a && a.maxXGap ? a.maxXGap : this.maxXGap, this.maxYGap = a && a.maxYGap ? a.maxYGap : this.maxYGap, this.maxTimeGap = a && a.maxTimeGap ? a.maxTimeGap : this.maxTimeGap, this.enabled = a && void 0 !== a.enabled ? a.enabled : this.enabled;
};

exports.GapBridgingConfig = GapBridgingConfig;